module.exports = __webpack_public_path__ + "media/src/components/shared/general/img/hhPortalLogo-58b167348cb6ad42f7ed3ed695db61de.png";